import "./../../style/favorites.css"
import {handleFavoritesChange} from "./utils/favoritesInteraction"
import Cookies from 'universal-cookie';
import { basename, jwtName } from "../../constants";

export default function PageListItem({title, id, isExercise, triggerUpdateAfterDelete}){
    const cookies = new Cookies()


    async function deleteFavorite(e){
        e.preventDefault()
        const jwt = cookies.get(jwtName)
        if(isExercise){
            await handleFavoritesChange(jwt, id, title, 1, 0)
        } else {
            await handleFavoritesChange(jwt, id, title, 0, 0)
        }
        await triggerUpdateAfterDelete()
    }

    return (
        <div className="favoritePageListItem shadow mb-2">
            <a href={basename + "/lerneinheiten/page/" + id} 
                className="max-w-sm p-6   ">
                    <p className="font-normal text-gray-700 dark:text-gray-400">{title}</p>
            </a>
            <a href={basename + "/favorites/pages"} 
                onClick={deleteFavorite}
                className="block max-w-sm p-6  hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <svg className="trashCan w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h16M7 8v8m4-8v8M7 1h4a1 1 0 0 1 1 1v3H6V2a1 1 0 0 1 1-1ZM3 5h12v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Z"/>
                    </svg>
            </a>
        </div>
    )
}